import React from 'react';
import { Button } from './';

/**
 * Composant de navigation par onglets générique
 * Permet de définir n'importe quel ensemble d'onglets sans valeurs prédéfinies
 */
export default function GenericTabNavigation({ tabs, activeTab, onTabChange, children }) {
  return (
    <div className="bg-white shadow-sm rounded-lg">
      {/* Tab Navigation */}
      <div className="wa-tabs__list border-b border-gray-200">
        <nav className="flex space-x-0" aria-label="Tabs">
          {tabs.map((tab) => (
                        <Button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              variant={activeTab === tab.id ? 'primary' : 'ghost'}
              className="px-3 py-2 font-medium text-sm rounded-md"
            >
              {tab.label}
            </Button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="wa-tabs__content p-6">
        {children}
      </div>
    </div>
  );
}
